<template>
	<div id="footer">
		<div class="kuang">
			<img src="@/images/footer_03.png" class="footer_logo"/>
			<div class="footer_nav">
				<ul>
					<li><router-link to="/">{{ $t('message.home') }}</router-link></li>
					<li><router-link to="/game">{{ $t('message.game') }}</router-link></li>
					<li><router-link to="/service">{{ $t('message.service') }}</router-link></li>
					<li><router-link to="/join">{{ $t('message.join') }}</router-link></li>
					<li><router-link to="/contact">{{ $t('message.contact') }}</router-link></li>
				</ul>
			</div>
			<div class="footer_contact">
				{{ $t('message.index65t') }}：{{ phone }}    │    {{ $t('message.index66t') }}：{{ email }}    │    {{ $t('message.index67t') }}：{{ address }}
			</div>
			<div class="footer_social">
				<a href="#"><img src="@/images/footer_07.png"/></a>
				<a href="#"><img src="@/images/footer_10.png"/></a>
				<a href="#"><img src="@/images/footer_12.png"/></a>
				<a href="#"><img src="@/images/footer_14.png"/></a>
			</div>
		</div>
		<div class="footer_cod">
			Copyright © 2023 KAI TECHNO PTE.LED All Rights Reserved
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
	  name: 'Footer',
	  data() {
	    return {
		  phone:'+65 8622 6688',
		  email:'kai@kaitech.com',
		  address:'10-80 Pasir Panjang Rd, Singapore 117438',
		  whatapp:'+65 8622 6688',
	    };
	  },
	  mounted() {
	  	//API 获取联系信息
	    //this.fetchContactInfo();
	  },
	  methods:{
		  scrollToSection(link) {
			this.$scrollToSection(link); // 调用全局方法
		  },
		  fetchContactInfo() {
			// 发起 API 请求
			axios
			  .get('/api/contact') 
			  .then(response => {
				// 请求成功，将获取的数据替换
  
			  })
			  .catch(error => {
				// 请求失败，显示错误信息
  
			  });
		  },
	  },
	};
</script>